module.exports = __webpack_public_path__ + "static/media/DSCF0027.4662e75a.jpg";